;(function () {
  'use strict'

  angular
    .module('contrast.tags')
    .factory('TagService', [
      'TagFactory',
      'ServiceUtils',
      'TAGGING_LABEL',
      TagService
    ])

  function TagService(TagFactory, ServiceUtils, TAGGING_LABEL) {
    var service = {
      getAvailableTagsForLibraries: getAvailableTagsForLibraries,
      getLibrariesTags: getLibrariesTags,
      addLibrariesTags: addLibrariesTags,
      removeLibrariesTags: removeLibrariesTags,
      onTaggingSelect: onTaggingSelect,
      getTaggingLabel: getTaggingLabel
    }

    return service

    function getAvailableTagsForLibraries() {
      return TagFactory.getAvailableTagsForLibraries()
        .then(ServiceUtils.handleResolve('data.tags'))
        .catch(ServiceUtils.handleError)
    }

    function getLibrariesTags(params) {
      return TagFactory.getLibrariesTags(params)
        .then(ServiceUtils.handleResolve('data'))
        .catch(ServiceUtils.handleError)
    }

    function addLibrariesTags(data) {
      return TagFactory.addLibrariesTags(data)
        .then(
          ServiceUtils.handleResolve('data', {
            log: ServiceUtils.LOGGER.SUCCESS
          })
        )
        .catch(ServiceUtils.handleError)
    }

    function removeLibrariesTags(data) {
      return TagFactory.removeLibrariesTags(data)
        .then(
          ServiceUtils.handleResolve('data', {
            log: ServiceUtils.LOGGER.SUCCESS
          })
        )
        .catch(ServiceUtils.handleError)
    }

    // Necessary until patch for https://github.com/angular-ui/ui-select/issues/1806 is created
    // or until we can fork ui-select and patch it ourselves
    function onTaggingSelect(path, $item) {
      var model = _getModelFromPath(this, path)
      var idx
      if ((idx = _.lastIndexOf(model, $item)) > -1) {
        var labelAndSpace = ' ' + TAGGING_LABEL
        if (model[idx].slice(-labelAndSpace.length) === labelAndSpace) {
          model[idx] = model[idx].slice(0, -labelAndSpace.length)
        }
      }
    }

    function _getModelFromPath(obj, path) {
      var steps = path.split('.')
      var last = obj
      for (var i = 0, len = steps.length; i < len; i++) {
        last = last[steps[i]]
      }
      return last
    }

    function getTaggingLabel() {
      return TAGGING_LABEL
    }
  }
})()
